import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=4bfd1d42&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Show.vue?vue&type=style&index=1&id=4bfd1d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd1d42",
  null
  
)

export default component.exports